/** File extensions rendered with the code icon in the workspace explorer. */
const CODE_FILE_EXTENSIONS: readonly string[] = [
  'ts',
  'tsx',
  'js',
  'jsx',
  'json',
  'css',
  'html',
  'rs',
  'py',
];

/** Returns whether a file name should be shown with the code file icon. */
export function isCodeFile(fileName: string): boolean {
  const extension = fileName.split('.').pop()?.toLowerCase() ?? '';
  return CODE_FILE_EXTENSIONS.includes(extension);
}

const MEDIA_TYPES: Readonly<Record<string, string>> = {
  apng: 'image/apng',
  avif: 'image/avif',
  bmp: 'image/bmp',
  gif: 'image/gif',
  jpeg: 'image/jpeg',
  jpg: 'image/jpeg',
  png: 'image/png',
  svg: 'image/svg+xml',
  webp: 'image/webp',
  m4v: 'video/x-m4v',
  mov: 'video/quicktime',
  mp4: 'video/mp4',
  ogv: 'video/ogg',
  webm: 'video/webm',
};

/** Returns the browser media MIME type for files the explorer can preview. */
export function previewMediaType(fileName: string): string | null {
  const extension = fileName.split('.').pop()?.toLowerCase() ?? '';
  return MEDIA_TYPES[extension] ?? null;
}
